import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";

const BatteryUsage = ({ soc = 0, offline }) => {
  const rectY = 56;
  const [height, setHeight] = useState(soc);
  const [y, setY] = useState(rectY);
  const rectMaxHeight = 45;
  const multiplier = 4.5;

  useEffect(() => {
    if (offline) {
      setHeight(0);
    } else {
      const newHeight = (soc * rectMaxHeight) / 100;
      setHeight(newHeight);

      const value = (soc / 10) * multiplier;
      setY(rectY - value);
    }
  }, [soc, offline]);

  return (
    <Box height="50px" sx={{ position: "relative" }}>
      <svg
        width="38"
        height="50"
        viewBox="0 0 38 61"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.2149 8.22446V2H26.3874V8.22446H36.0843V59.1873H1.77197V8.22446H12.2149Z"
          stroke="#F9B426"
          strokeWidth="2.8"
          strokeLinecap="round"
        />
        <rect
          x="5.53198"
          y={y}
          width="26.4499"
          height={height}
          fill="#F9B426"
          stroke="#F9B426"
        />
      </svg>

      <Typography
        variant="caption"
        fontWeight={700}
        sx={{
          position: "absolute",
          top: "20px",
          left: "7px",
          minWidth: "24px",
          textAlign: "center",
        }}
      >
        {offline ? "NA" : `${soc ? soc.toFixed(0) : 0}%`}
      </Typography>
    </Box>
  );
};

export default BatteryUsage;
